import type { RouteRecordRaw, RouteLocationNormalized } from "vue-router";
import { parseDate } from "@/helpers/time";

export const TRANSPORTATION_DOCUMENT_NAME = "transportation-document-create";

export const routes: RouteRecordRaw[] = [
  {
    path: "transportation-docs",
    children: [
      {
        path: "",
        name: "transportation-docs",
        component: () => import("./views/TransportDocumentTab.vue"),
        meta: {
          requiresAuth: true,
          title: "Transportdokument",
          view: "tabs",
        },
      },
      {
        path: "create",
        name: TRANSPORTATION_DOCUMENT_NAME,
        props: (route: RouteLocationNormalized) => ({
          date: typeof route.query.date === "string" ? parseDate(route.query.date) : undefined,
          workOrderId: route.params.id,
        }),
        meta: {
          requiresAuth: true,
          title: "Transportdokumentation för avfallshantering",
        },
        component: () => import("./views/TransportDocumentCreate.vue"),
      },
      {
        path: "view/:documentId",
        name: "transport-document-view",
        component: () => import("./views/TransportDocumentView.vue"),
        props: (route: RouteLocationNormalized) => ({
          workOrderId: route.params.id,
          id: route.params.documentId,
        }),
      },
      {
        path: "edit/:documentId",
        name: "transport-document-edit",
        component: () => import("./views/TransportDocumentEdit.vue"),
        props: (route: RouteLocationNormalized) => ({
          workOrderId: route.params.id,
          id: route.params.documentId,
        }),
      },
    ],
  },
];
